// Shared framer-motion variants and helpers for FaMa Apartments.

export const easeLux = [0.16, 1, 0.3, 1];

export const fadeUp = {
    hidden: { opacity: 0, y: 34 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.9, ease: easeLux },
    },
};

export const staggerParent = (stagger = 0.12, delayChildren = 0.05) => ({
    hidden: {},
    show: {
        transition: { staggerChildren: stagger, delayChildren },
    },
});

// Masked line reveal: wrap text in overflow-hidden, animate child span up.
export const lineChild = {
    hidden: { y: "110%" },
    show: {
        y: "0%",
        transition: { duration: 1, ease: easeLux },
    },
};

export const viewportOnce = { once: true, amount: 0.25 };
